module.exports = __webpack_public_path__ + "static/media/delphi.5b1f0610.jpeg";